module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cl":{"error-getBrokersList":"Ocurrió un error al tratar de obtener los brokers.","list-title":"Brokers disponibles"},"pe":{"error-getBrokersList":"Ocurrió un error al tratar de obtener los brokers.","list-title":"Brokers disponibles"},"br":{"error-getBrokersList":"Ocorreu um erro ao tentar obter os brokers.","list-title":"Brokers disponíveis"}}')
  delete Component.options._Ctor
}
